import {
  Card,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export function TableStatus({
  productTransaction,
  productTransactionExport,
  customer,
  loading,
  product
}) {
  const [customerStack, setCustomerStack] = useState([]);
  const [customerStackExport, setCustomerStackExport] = useState([]);
  const [orderType, setOrderType] = useState('IMPORT');
  const [orderProductType, setOrderProductType] = useState('IMPORT');

  // console logs for debugging
  // console.log("customer in main dashboard", customer);
  // console.log("product in main dashboard", product);
  // console.log("customerStack in main dashboard", customerStack);
  // console.log("customerStackExport in main dashboard", customerStackExport);
  // console.log("productTransaction in main dashboard", productTransaction);
  // console.log("productTransactionExport in main dashboard", productTransactionExport);

  useEffect(() => {
    if (productTransaction?.customerGroup?.length > 0 && customer?.length > 0) {
      const customerGroup = productTransaction.customerGroup;

      // เชื่อมโยง customerId จาก customerGroup กับข้อมูลใน customer
      const newCustomerStack = customerGroup.map((customerGroupItem) => {
        // หาลูกค้าที่ตรงกับ customerId
        const customerMatch = customer.find(
          (eachCustomer) => eachCustomer._id === customerGroupItem.customerId
        );

        // ถ้าหาลูกค้าเจอให้คืนค่าชื่อและ count ของลูกค้า
        if (customerMatch) {
          return {
            customer: customerMatch,
            count: customerGroupItem.count,
          };
        }
        return null; // ถ้าไม่พบก็คืนค่า null
      }).filter(Boolean); // กรองค่า null ออก

      setCustomerStack(newCustomerStack);
    }
  }, [productTransaction?.customerGroup, customer]); // ให้ useEffect ทำงานเมื่อข้อมูล customerGroup หรือ customer เปลี่ยนแปลง

  useEffect(() => {
    if (productTransactionExport?.customerGroup?.length > 0 && customer?.length > 0) {
      const customerGroup = productTransactionExport.customerGroup;

      // เชื่อมโยง customerId จาก customerGroup กับข้อมูลใน customer
      const newCustomerStackExport = customerGroup.map((customerGroupItem) => {
        // หาลูกค้าที่ตรงกับ customerId
        const customerMatch = customer.find(
          (eachCustomer) => eachCustomer._id === customerGroupItem.customerId
        );

        // ถ้าหาลูกค้าเจอให้คืนค่าชื่อและ count ของลูกค้า
        if (customerMatch) {
          return {
            customer: customerMatch,
            count: customerGroupItem.count,
          };
        }
        return null; // ถ้าไม่พบก็คืนค่า null
      }).filter(Boolean); // กรองค่า null ออก

      setCustomerStackExport(newCustomerStackExport);
    }
  }, [productTransactionExport?.customerGroup, customer]); // ให้ useEffect ทำงานเมื่อข้อมูล customerGroup หรือ customer เปลี่ยนแปลง

  const renderTableCustomer = () => (
    <>
      <Paper>
        <TableContainer component={Paper}>
          <Table size="small" className="border-lg">
            <colgroup>
              <col width="20%" />
              <col width="60%" />
              <col width="20%" />
            </colgroup>
            <TableHead className="bg-yellow-300">
              <TableRow>
                <TableCell>
                  <div className="font-bold py-2">อันดับ</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> ชื่อลูกค้า</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> ยอดนำเข้า</div>
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      </Paper>
      <div className="max-h-96 overflow-y-auto">
        <Paper>
          <TableContainer component={Paper}>
            <Table size="small" className="border-lg">
              <TableBody>
                {_.map(
                  _.sortBy(
                    orderType === 'IMPORT'
                      ? customerStack
                      : customerStackExport,
                    ['customer', 'amount']
                  )
                    .reverse()
                    .slice(0, 10),
                  (EachCustomer, index) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      className="hover:bg-yellow-100 py-2"
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        {!loading ? (
                          <div className="font-bold my-auto py-2">
                            {EachCustomer?.customer?.name}
                          </div>
                        ) : (
                          'กำลังคำนวณ...'
                        )}
                      </TableCell>
                      <TableCell>
                        <div className="text-center">
                          {!loading && EachCustomer.count || 0}
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </>
  );

  const handleChangeOrderType = (value) => {
    if (value === 'IMPORT') {
      setOrderType('IMPORT');
    } else if (value === 'EXPORT') {
      setOrderType('EXPORT');
    } else {
      setOrderType('RESERVE');
    }
  };

  const handleChangeOrderProductType = (value) => {
    if (value === 'IMPORT') {
      setOrderProductType('IMPORT');
    } else if (value === 'EXPORT') {
      setOrderProductType('EXPORT');
    } else {
      setOrderProductType('RESERVE');
    }
  };

  const renderTopCustomers = () => (
    <Card className="p-6">
      <div className="">
        <div className="pb-2 text-xl flex justify-between">
          <div>รายการลูกค้าส่งออกมากที่สุด</div>
          <div>
            <div className="flex justify-start">
              <div className="bg-white">
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel id="type" size={'small'}>
                    เลือกรายการ
                  </InputLabel>
                  <Select
                    label="เลือกรายการ"
                    size={'small'}
                    fullWidth
                    defaultValue="IMPORT"
                    onChange={(e) => {
                      handleChangeOrderType(e.target.value);
                    }}
                  >
                    <MenuItem value="IMPORT">การนำเข้า</MenuItem>
                    <MenuItem value="EXPORT">การส่งออก</MenuItem>
                    {/* <MenuItem value="RESERVE">การจอง</MenuItem> */}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </div>
        {renderTableCustomer()}
      </div>
    </Card>
  );

  const renderTopProduct = () => (
    <Card className="p-6">
      <div className="">
        <div className="pb-2 text-xl flex justify-between">
          <div>รายการสินค้าส่งออกมากที่สุด</div>
          <div>
            <div className="flex justify-start">
              <div className="bg-white">
                <FormControl sx={{ minWidth: 200 }}>
                  <InputLabel id="type" size={'small'}>
                    เลือกรายการ
                  </InputLabel>
                  <Select
                    label="เลือกรายการ"
                    size={'small'}
                    fullWidth
                    defaultValue="IMPORT"
                    onChange={(e) => {
                      handleChangeOrderProductType(e.target.value);
                    }}
                  >
                    <MenuItem value="IMPORT">การนำเข้า</MenuItem>
                    <MenuItem value="EXPORT">การส่งออก</MenuItem>
                    <MenuItem value="RESERVE">การจอง</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </div>
        {renderTableProduct()}
      </div>
    </Card>
  );

  const renderTableProduct = () => {
    const ordersGroupImport = productTransaction.ordersGroup;
    const ordersGroupExport = productTransactionExport.ordersGroup;
    const ordersGroupReserve = productTransactionExport.ordersReturnGroup;

    const productImportIds = ordersGroupImport?.flatMap((order) => {
      return order?.product?.map((productId, index) => ({
        productId,
        totalAmount: order.totalAmount[index],
      }));
    });

    const productExportIds = ordersGroupExport?.flatMap((order) => {
      return order?.product?.map((productId, index) => ({
        productId,
        totalAmount: order.totalAmount[index],
      }));
    });

    const productReserveIds = ordersGroupReserve?.flatMap((order) => {
      return order?.product?.map((productId, index) => ({
        productId,
        totalAmount: order.totalAmount[index],
      }));
    });

    // รวมยอด totalAmount ของ productId ที่ซ้ำกัน
    const combinedImportProducts = productImportIds.reduce((acc, product) => {
      const existingProduct = acc.find(p => p.productId === product.productId);
      if (existingProduct) {
        existingProduct.totalAmount += product.totalAmount;
      } else {
        acc.push({ ...product });
      }
      return acc;
    }, []);

    const combinedExportProducts = productExportIds.reduce((acc, product) => {
      const existingProduct = acc.find(p => p.productId === product.productId);
      if (existingProduct) {
        existingProduct.totalAmount += product.totalAmount;
      } else {
        acc.push({ ...product });
      }
      return acc;
    }, []);

    const combinedReserveProducts = productReserveIds.reduce((acc, product) => {
      const existingProduct = acc.find(p => p.productId === product.productId);
      if (existingProduct) {
        existingProduct.totalAmount += product.totalAmount;
      } else {
        acc.push({ ...product });
      }
      return acc;
    }, []);

    // Map productId กับข้อมูลจาก product
    const mapProductDetails = (productId) => {
      const productDetails = product.find(p => p._id === productId);
      return productDetails || {}; // ถ้าไม่เจอให้คืนค่าเป็นอ็อบเจ็กต์เปล่า
    };

    return (
      <>
        <Paper>
          <TableContainer component={Paper}>
            <Table size="small" className="border-lg">
              <colgroup>
                <col width="20%" />
                <col width="60%" />
                <col width="20%" />
              </colgroup>
              <TableHead className="bg-yellow-300">
                <TableRow>
                  <TableCell>
                    <div className="font-bold py-2">อันดับ</div>
                  </TableCell>
                  <TableCell>
                    <div className="font-bold"> รหัสสินค้า (model name)</div>
                  </TableCell>
                  <TableCell>
                    <div className="font-bold"> จำนวน</div>
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        </Paper>
        <div className="max-h-96 overflow-y-auto">
          <Paper>
            <TableContainer component={Paper}>
              <Table size="small" className="border-lg">
                <TableBody>
                  {orderProductType === 'IMPORT' ? combinedImportProducts?.map((product) => {
                    const productDetails = mapProductDetails(product.productId);
                    return (
                      <TableRow
                        key={product.productId} // ใช้ productId เป็น key
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        className="hover:bg-yellow-100 py-2"
                      >
                        <TableCell>{combinedImportProducts?.indexOf(product) + 1}</TableCell>
                        <TableCell>
                          {/* การตัดคำถ้ายาวเกิน */}
                          {!loading ? (<div className="text-ellipsis overflow-hidden" style={{ maxWidth: '200px', whiteSpace: 'nowrap' }}>
                            {productDetails.model_name ?
                              (productDetails.model_name.length > 20 ? `${productDetails.model_name.substring(0, 20)}...` : productDetails.model_name) : 'ไม่มีข้อมูล'}
                          </div>) : ('กำลังคำนวณ...')}
                        </TableCell>
                        <TableCell>
                          <div className="text-center">{product.totalAmount}</div>
                        </TableCell>
                      </TableRow>
                    );
                  }) : orderProductType === 'EXPORT' ? combinedExportProducts?.map((product) => {
                    const productDetails = mapProductDetails(product.productId);
                    return (
                      <TableRow
                        key={product.productId} // ใช้ productId เป็น key
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        className="hover:bg-yellow-100 py-2"
                      >
                        <TableCell>{combinedExportProducts?.indexOf(product) + 1}</TableCell>
                        <TableCell>
                          {/* การตัดคำถ้ายาวเกิน */}
                          {!loading ? (<div className="text-ellipsis overflow-hidden" style={{ maxWidth: '200px', whiteSpace: 'nowrap' }}>
                            {productDetails.model_name ?
                              (productDetails.model_name.length > 20 ? `${productDetails.model_name.substring(0, 20)}...` : productDetails.model_name) : 'ไม่มีข้อมูล'}
                          </div>) : ('กำลังคำนวณ...')}
                        </TableCell>
                        <TableCell>
                          <div className="text-center">{product.totalAmount}</div>
                        </TableCell>
                      </TableRow>
                    );
                  }) : combinedReserveProducts?.map((product) => {
                    const productDetails = mapProductDetails(product.productId);
                    return (
                      <TableRow
                        key={product.productId}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        className="hover:bg-yellow-100 py-2"
                      >
                        <TableCell>{combinedReserveProducts?.indexOf(product) + 1}</TableCell>
                        <TableCell>
                          {!loading ? (
                            <div className="text-ellipsis overflow-hidden" style={{ maxWidth: '200px', whiteSpace: 'nowrap' }}>
                              {productDetails.model_name ?
                                (productDetails.model_name.length > 20 ? `${productDetails.model_name.substring(0, 20)}...` : productDetails.model_name) : 'ไม่มีข้อมูล'}
                            </div>
                          ) : 'กำลังคำนวณ...'}
                        </TableCell>
                        <TableCell>
                          <div className="text-center">{product.totalAmount}</div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      </>
    );
  };

  if (!loading) {
    return (
      <>
        {renderTopCustomers()}
        {renderTopProduct()}
      </>
    );
  }

  return (
    <>
      {renderTopCustomers()}
      {renderTopProduct()}
    </>
  );
}

TableStatus.propTypes = {
  productTransaction: PropTypes.object,
  productTransactionExport: PropTypes.object,
  product: PropTypes.array,
  customer: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  loading: PropTypes.bool,
};

TableStatus.defaultProps = {
  productTransaction: null,
  productTransactionExport: null,
  product: null,
  customer: null,
  loading: null,
};

export default TableStatus;